import 'bootstrap/dist/css/bootstrap.css';
import 'handsontable/dist/handsontable.full.css';
import { costBaseThousandsNA, dismissWarning, formatNumber, getResponseValue, injectPlaceholder, isFeeBasisNA, localizeNumber, normalizeSelectInput, performanceFeesNA, toNumber, underlyingFeesNA, useDefaultWarning } from '../../../../helpers';
import { convertTeamToID, DbSortFunctionForAssets, isDerivativesCategory, isInternalStyle, mapInternalTeam, refreshDefaults, returnTypeIDOptions, getOptionsArray, mapToDropdownOption, mapCustomGroupings, convertCustomGroupingToID } from '../../../../ibsHelper';
import ibsStore from '../../../Stores/IbsSurveyStore';
import store from '../../../Stores/SurveyStore';
import { AssetTableViewMode, NumberFormat, SelectCombosIBS, PlaceholderFormat } from '../../../../Enums/constants';
import { calculateTotal, calculateForChildren } from '../../../../Helpers/TableCalculationHelper';

export const RowFactory = {
    CreateCategoryHeaderRow: (categoryName) => {
        let currencyPlaceHolderMilsForHeader = `|${PlaceholderFormat.CURRENCY_MILS}|`;
        let currencyPlaceHolderThousandsForHeader = `|${PlaceholderFormat.CURRENCY_THOUSANDS}|`;

        return store.questionMode ?
            {
                AssetClassCategoryName: "AssetClassCategoryName", AssetClassName: "AssetClassName", StyleName: "StyleName", HoldingsMillions: "HoldingsMillions", test1: null, ReturnPercent: null, Holdings: null, ReturnPercent2: null, CostBaseFeesThousands: null, InternalMonitoringCost: null, test2: null, test3: null, test4: null, test5: null, Internal: null, RowID: null, del: "", __children: null
            }
            : {
                AssetClassCategoryName: categoryName,
                AssetClassName: "",
                AssetClassNameReal: "",
                StyleName: "",
                ManagerName: "",
                FundName: "",
                HoldingNavAvg: "",
                HoldingNavEnd: "",
                ReturnPct: isDerivativesCategory(categoryName) ? "Profit/Loss \n " + injectPlaceholder(currencyPlaceHolderThousandsForHeader) + "<i class='fas fa-info-circle fa-xs tooltipCustom'><span class='genericTooltip tooltiptext infoBubble'>Profit/Loss <br/><br/> Provide the profit or loss on the derivative program. In cases where there is a 'policy' component to return (for example, discretionary currency hedging where it is policy to be 50% hedged), profit/loss should be relative to the passive alternative.</span></i> " : "",
                ReturnTypeIDAssets: "",
                CostManagerBase: "",
                CostManagerPerf: "",
                CostUnderlyBase: "",
                CostUnderlyPerf: "",
                CostInternManage: "",
                totalRowCost: "",
                HoldingFeeAvg: isDerivativesCategory(categoryName) ? "Notional Amount \n " + injectPlaceholder(currencyPlaceHolderMilsForHeader) + "<i class='fas fa-info-circle fa-xs tooltipCustom'><span class='genericTooltip tooltiptext infoBubble'>Notional amount <br/><br/>  Notional amount refers to the amount used as a base for computing cash flows in a derivatives contract.Provide gross(long + short) notional amounts, with the following exceptions: <br/> • For Duration overlays please provide the NET exposure amount. <br/> • For Policy Tilt TAA programs and discretionary currency programs, notional amount should reflect the total assets over which the overlay manager has discretion. <br/> • For externally managed long - short, Global TAA and Commodity Future programs, notional amount is the nominal asset base on which returns and fees are calculated.</span></i>" : "",
                HoldingFeeEnd: "",
                CustomAssetID: "",
                InternalTeamID: "",
                DataYear: "",
                LifeCycleStatus: "",
                ReportIncludeStatus: "",
                action: "",
                RowID: "",
                del: "",
                __children: null
            }
    },

    CreateMandateRow: (mandate, parentAssetRowID) => {
        let managerFundAccountConcat = (mandate.managerName ? mandate.managerName : "")
            + (mandate.fundName ? " - " + mandate.fundName : "")
            + (mandate.accountCode ? " - " + mandate.accountCode : "")

        let assetStyleConcat = (mandate.assetClassName ? mandate.assetClassName : "")
            + (mandate.styleName ? " - " + mandate.styleName : "")

        return {
            __AssetClassCategoryName: mandate.assetClassCategoryName,
            AssetClassCategoryName: mandate.assetClassCategoryName,
            AssetClassName: ibsStore.checkMandateLevel == AssetTableViewMode.BOTH_VIEW ? ("&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" + managerFundAccountConcat) : ibsStore.checkMandateLevel == AssetTableViewMode.MANDATE_ONLY_VIEW ? "&nbsp;&nbsp;&nbsp;" + assetStyleConcat : "",
            AssetClassNameReal: mandate.assetClassName,
            StyleName: mandate.styleName ?? "",
            ManagerName: "&nbsp;&nbsp;&nbsp;" + managerFundAccountConcat,
            FundName: mandate.fundName,
            HoldingNavAvg: localizeNumber(mandate.holdingNavAvg),
            HoldingNavEnd: localizeNumber(mandate.holdingNavEnd),
            ReturnPct: isDerivativesCategory(mandate.assetClassCategoryName) ? localizeNumber(mandate.derivProfit) : (mandate.isReturnNA ? "N/A" : localizeNumber(mandate.returnPct)),
            ReturnTypeIDAssets: mapToDropdownOption(mandate.returnTypeIDAssets, SelectCombosIBS.ASSET_RETURN_TYPES),
            CostManagerBase: localizeNumber(mandate.costManagerBase),
            CostManagerPerf: localizeNumber(mandate.costManagerPerf),
            CostUnderlyBase: localizeNumber(mandate.costUnderlyBase),
            CostUnderlyPerf: localizeNumber(mandate.costUnderlyPerf),
            CostInternManage: localizeNumber(isInternalStyle(mandate.styleID) ? mandate.costInternManage : mandate.costInternMonitor),
            totalRowCost: localizeNumber(calculateTotal([
                mandate.costManagerBase, mandate.costManagerPerf, mandate.costUnderlyBase,
                mandate.costUnderlyPerf,
                isInternalStyle(mandate.styleID) ? mandate.costInternManage : mandate.costInternMonitor], mandate.rowID)),
            HoldingFeeAvg: isDerivativesCategory(mandate.assetClassCategoryName) ? localizeNumber(mandate.notionalAmount) : localizeNumber(mandate.holdingFeeAvg),
            HoldingFeeEnd: isDerivativesCategory(mandate.assetClassCategoryName) ? localizeNumber(mandate.notionalAmount) : localizeNumber(mandate.holdingFeeEnd),
            CustomAssetID: mapCustomGroupings(mandate.customAssetID),
            InternalTeamID: mapInternalTeam(mandate.internalTeamID),
            LifeCycleStatus: handleLifecycleStatus(mandate.lifeCycleStatus, mandate.mandateYearStart, mandate.mandateYearEnd),
            ReportIncludeStatus: mapToDropdownOption(mandate.reportIncludeStatus, SelectCombosIBS.REPORT_INCLUSION_OPTS),
            RowID: mandate.rowID,
            ParentAssetRowId: parentAssetRowID ? parentAssetRowID : "parentRowId",
            action: " <i class='fa fa-pen del-row-icon' onClick={myFunction()} aria-hidden='true' title='Edit Row'></i>",
            MandateID: mandate?.mandateID ?? ""
        };
    },

    /**
     * Creates asset class row that depends on whether it has mandate children or not. <br />
     * Pass empty array to mandates if no children <br />
     * 
     * THIS FUNCTION DOES NOT ADD CHILDREN TO THE ASSET ROW, DO THIS SEPARATELY
     * 
     * @param {Object} asset the asset data for the row
     * @param {Array} mandates array of mandates as children for the asset row
     * @returns {Object} asset row to put into handsontable
     */
    CreateAssetRow: (asset, mandates, listOfOverrides, listOfCalculated) => {
        if (asset === null || asset === undefined) return {};
        if (mandates === null || mandates === undefined || !Array.isArray(mandates)) mandates = []
        if (mandates.length == 0) {
            // does not have mandate rows for children, can ignore mandate, just use values from the asset object
            return {

                AssetClassCategoryName: asset.AssetClassCategoryName,
                AssetClassName: "&nbsp;&nbsp;&nbsp;" + asset.AssetClassName + " - " + asset.StyleName,
                AssetClassNameReal: asset.AssetClassName,
                StyleName: asset.StyleName,
                ManagerName: "",
                FundName: "",
                HoldingNavAvg: localizeNumber(asset.HoldingsMillions),
                HoldingNavEnd: localizeNumber(asset.HoldingsMillions),
                ReturnPct: isDerivativesCategory(asset.AssetClassCategoryName) ? localizeNumber(asset.DerivPerfThousands) : (asset.IsReturnNA ? "N/A" : localizeNumber(asset.ReturnPercent)),
                ReturnTypeIDAssets: mapToDropdownOption(asset.ReturnTypeIDAssets, SelectCombosIBS.ASSET_RETURN_TYPES),
                CostManagerBase: localizeNumber(asset.CostBaseFeesThousands),
                CostManagerPerf: localizeNumber(asset.CostPerformanceThousands),
                CostUnderlyBase: localizeNumber(asset.UnderlyingFundFees),
                CostUnderlyPerf: localizeNumber(asset.UnderlyingPerfFees),
                CostInternManage: isInternalStyle(asset.StyleID) ? localizeNumber(asset.CostThousands) : localizeNumber(asset.InternalMonitoringCost),
                totalRowCost: localizeNumber(calculateTotal([asset.CostBaseFeesThousands,
                asset.CostPerformanceThousands, asset.UnderlyingFundFees,
                asset.UnderlyingPerfFees,
                isInternalStyle(asset.StyleID) ? asset.CostThousands : asset.InternalMonitoringCost], asset.RowID)),
                HoldingFeeAvg: isDerivativesCategory(asset.AssetClassCategoryName) ? localizeNumber(asset.NotionalAmount) : localizeNumber(asset.FeesPaidHoldingsMillions),
                HoldingFeeEnd: localizeNumber(asset.FeesPaidHoldingsMillions),
                CustomAssetID: mapCustomGroupings(asset.CustomAssetID),
                InternalTeamID: mapInternalTeam(asset.InternalTeamID),
                LifeCycleStatus: "",
                ReportIncludeStatus: mapToDropdownOption(asset.ReportIncludeStatus, SelectCombosIBS.REPORT_INCLUSION_OPTS),
                RowID: "A" + asset.RowID,
                action: "<i class='fa fa-minus-circle del-row-icon' onClick={myFunction()} aria-hidden='true' title='Delete Row'></i>",
                __children: null

            }
        } else {
            // has mandate rows, so needs to take mandate values into account when making the asset row
            const totalCostManagerBase = calculateForChildren(mandates, "costManagerBase", asset.CostBaseFeesThousands, asset.RowID, listOfOverrides, listOfCalculated)
            const totalCostManagerPerf = calculateForChildren(mandates, "costManagerPerf", asset.CostPerformanceThousands, asset.RowID, listOfOverrides, listOfCalculated)
            const totalUnderlyBase = calculateForChildren(mandates, "costUnderlyBase", asset.UnderlyingFundFees, asset.RowID, listOfOverrides, listOfCalculated)
            const totalUnderlyPerf = calculateForChildren(mandates, "costUnderlyPerf", asset.UnderlyingPerfFees, asset.RowID, listOfOverrides, listOfCalculated)
            const totalInternalCosts = calculateForChildren(mandates,
                isInternalStyle(asset.StyleID) ? "costInternManage" : "costInternMonitor",
                isInternalStyle(asset.StyleID) ? asset.CostThousands : asset.InternalMonitoringCost, asset.RowID, listOfOverrides, listOfCalculated)
            return {
                AssetClassCategoryName: asset.AssetClassCategoryName,
                AssetClassName: "&nbsp;&nbsp;&nbsp;" + asset.AssetClassName + " - " + asset.StyleName,
                AssetClassNameReal: asset.AssetClassName,
                StyleName: asset.StyleName,
                ManagerName: "",
                FundName: "",
                HoldingNavAvg: localizeNumber(calculateForChildren(mandates, "holdingNavAvg", asset.HoldingsMillions, asset.RowID, listOfOverrides, listOfCalculated)),
                HoldingNavEnd: localizeNumber(calculateForChildren(mandates, "holdingNavEnd", asset.HoldingsMillions, asset.RowID, listOfOverrides, listOfCalculated)),
                ReturnPct: localizeNumber(calculateForChildren(mandates, isDerivativesCategory(asset.AssetClassCategoryName) ? "derivProfit" : "returnPct", isDerivativesCategory(asset.AssetClassCategoryName) ? localizeNumber(asset.DerivPerfThousands) : (asset.IsReturnNA ? "N/A" : localizeNumber(asset.ReturnPercent)), asset.RowID, listOfOverrides, listOfCalculated)),
                ReturnTypeIDAssets: mapToDropdownOption(asset.ReturnTypeIDAssets, SelectCombosIBS.ASSET_RETURN_TYPES),
                CostManagerBase: localizeNumber(totalCostManagerBase),
                CostManagerPerf: localizeNumber(totalCostManagerPerf),
                CostUnderlyBase: localizeNumber(totalUnderlyBase),
                CostUnderlyPerf: localizeNumber(totalUnderlyPerf),
                CostInternManage: localizeNumber(totalInternalCosts),
                totalRowCost: localizeNumber(calculateTotal([totalCostManagerBase, totalCostManagerPerf, totalUnderlyBase, totalUnderlyPerf, totalInternalCosts], asset.RowID)),
                HoldingFeeAvg: localizeNumber(calculateForChildren(mandates, isDerivativesCategory(asset.AssetClassCategoryName) ? "notionalAmount" : "holdingFeeAvg", isDerivativesCategory(asset.AssetClassCategoryName) ? localizeNumber(asset.NotionalAmount) : localizeNumber(asset.FeesPaidHoldingsMillions), "A" + asset.RowID, listOfOverrides, listOfCalculated)),
                HoldingFeeEnd: localizeNumber(calculateForChildren(mandates, "holdingFeeEnd", localizeNumber(asset.FeesPaidHoldingsMillions), asset.RowID, listOfOverrides, listOfCalculated)),
                CustomAssetID: mapCustomGroupings(asset.CustomAssetID),
                InternalTeamID: mapInternalTeam(asset.InternalTeamID),
                ReportIncludeStatus: mapToDropdownOption(asset.ReportIncludeStatus, SelectCombosIBS.REPORT_INCLUSION_OPTS),
                LifeCycleStatus: "",
                RowID: "A" + asset.RowID,
                action: " ",
                __children: null
            }
        }
    }
}

const handleLifecycleStatus = (lifecycleStatus, startYear, endYear) => {
    let selectedLifecycleStatus = mapToDropdownOption(lifecycleStatus, SelectCombosIBS.LIFECYCLE_TYPES)
    if (selectedLifecycleStatus == "New" && startYear < ibsStore.currentSurvey.DataYear && startYear != null) {
        return ""
    } else if (selectedLifecycleStatus == "Terminated" && endYear > ibsStore.currentSurvey.DataYear && endYear != null) {
        return ""
    }
    return selectedLifecycleStatus
}